import type { PropsWithChildren} from 'react';
import { useEffect, useState } from 'react';
import * as style from './OpenMapApplicationAction.module.css';

function getDevice() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)?.[0];
}

function getUrl(device: string | undefined, { latitude, longitude, place }: Props) {
    switch (device) {
        case 'iphone':
        case 'ipad':
        case 'ipod':
            return `http://maps.apple.com/?q=${place}&sll=${latitude},${longitude}&z=15&t=s`;
        case 'android':
            return `geo:${latitude},${longitude}?q=${place}`;
        default:
            return `http://maps.google.com/maps/search/${place}/@${latitude},${longitude},15z`;
    }
}

interface Props {
    latitude: number;
    longitude: number;
    place: string;
}

export default function OpenMapApplicationAction({ children, ...props }: PropsWithChildren<Props>) {
    const [device, setDevice] = useState<string>();

    useEffect(() => {
        setDevice(getDevice());
    }, []);

    return (
        <a href={getUrl(device, props)} target={device ? '_self' : '_blank'} className={style.linkToMap} rel="noreferrer">
            {children}
        </a>
    );
}
